import { z } from 'zod';

/**
 * Per-call cost record for LLM/OCR providers (REQ7.5, ADR-0004). Aggregated
 * to `invoices.cost_cents` and surfaced per-customer in the admin overview.
 */
export const CostProviderEnum = z.enum([
  'gemini',
  'mistral',
  'anthropic',
  'workers-ai',
  'ollama',
  'mock',
]);
export type CostProvider = z.infer<typeof CostProviderEnum>;

export const CostKindEnum = z.enum(['ocr', 'llm']);
export type CostKind = z.infer<typeof CostKindEnum>;

export const CostEventSchema = z.object({
  id: z.string(),
  invoiceId: z.string(),
  /** OCR or LLM call. */
  kind: CostKindEnum,
  provider: CostProviderEnum,
  model: z.string(),
  /** Token counts only meaningful for LLM. OCR uses pages/millis instead. */
  inputTokens: z.number().int().nonnegative().optional(),
  outputTokens: z.number().int().nonnegative().optional(),
  /** Page count for OCR providers, undefined for LLM. */
  pages: z.number().int().nonnegative().optional(),
  /** Whole cents (EUR), integer to avoid float math on aggregates. */
  costCents: z.number().int().nonnegative(),
  createdAt: z.string().datetime(),
});
export type CostEvent = z.infer<typeof CostEventSchema>;
